// Returns the origin role of a peptide order:
//   "patient" | "provider" | "manufacturer" | "unknown"
//
// The order vertex doesn't carry an explicit `placedBy` enum today — instead it
// has `placedByPatient` (boolean) and `source` (string). This helper consolidates
// those into a single 4-way value so the kanban classifier and filter logic can
// reason about origin uniformly.
//
// Priority chain:
//   1. placedByPatient === true → "patient"
//   2. source === "provider" OR "patient-intake" → "provider"
//      (patient-intake is the provider-on-behalf-of-patient flow; the provider
//      initiated it, so it counts as provider-placed)
//   3. source === "manufacturer" OR "manufacturer-portal" → "manufacturer"
//   4. otherwise → "unknown" (legacy data, missing fields, contradictory shape)
//
// "unknown" is treated specially by the classifier — these orders appear in
// All views only, never in role-filtered views. This prevents legacy orders
// (predating the `source` field) from being silently mis-categorized into
// the wrong role's My Orders queue.
export function getOrderOrigin(order) {
  if (!order) return "unknown";
  if (order.placedByPatient === true) return "patient";
  // A manufacturer-placed order shown on the assigned clinic's board: the FE
  // stamps providerInbound per-viewer (see getPeptideOrders). It routes into
  // the clinic's provider lanes without clobbering the real `source`.
  if (order.providerInbound === true) return "provider";
  // "stack-builder" is the provider-initiated outreach flow (patient submits a
  // quiz via a provider's stack-builder link). The provider initiated it, so
  // it counts as provider-placed even though the patient submits.
  if (order.source === "provider" || order.source === "patient-intake" || order.source === "stack-builder") return "provider";
  if (order.source === "manufacturer" || order.source === "manufacturer-portal") return "manufacturer";
  return "unknown";
}
